import React from "react";
import { useNavigate } from "react-router-dom";
import styled from "styled-components";
import { Colors, Text, TextFont } from "../../config";
import Button from "../Button";
import Modal from "../Modal";
import { useMsal } from "@azure/msal-react";
import { useIsAuthenticated } from "@azure/msal-react";
import { useBookingContext } from "../../contexts/BookingContext";
import { useGuestContext } from "../../contexts/GuestContext";
import { usePaxContext } from "../../contexts/PassengerContext";
import { BOOKING_INIT } from "../../config/Constants";
import { deleteTokenRegister } from "../../services/userServices";
import { deleteRegToken } from "../../firebaseNotifications/firebase";
const logoutImg = require("../../assets/images/LogoutImg.png");

const LogoutModal = ({ setClose }) => {
  const navigate = useNavigate();
  const { instance } = useMsal();
  const isAuthenticated = useIsAuthenticated();
  const { setBooking } = useBookingContext();
  const { setGuests } = useGuestContext();
  const { setPax } = usePaxContext();

  const onLogout = async () => {
    let token = localStorage.getItem("firebaseEmployeeToken");
    try {
      if (token) {
        console.log("Hey there token is there", token);
        await deleteRegToken();
        await deleteTokenRegister({ token });
      }
      localStorage.removeItem("token");
      localStorage.removeItem("roleEmployee");
      localStorage.removeItem("employeeData");
      // localStorage.removeItem("firebaseEmployeeToken");
      localStorage.removeItem("userId");
      setGuests([]);
      setPax([]);
      let resetBooking = JSON.parse(JSON.stringify(BOOKING_INIT));
      setBooking(resetBooking);
      navigate("/auth/login");
      if (isAuthenticated) {
        instance.logoutPopup({
          postLogoutRedirectUri: "/",
          mainWindowRedirectUri: "/",
        });
      }
    } catch (err) {
      console.log(err);
    }
  };
  return (
    <Modal setClose={setClose}>
      <LogoutContainer>
        <img src={logoutImg} alt="logout" />
        <TextFont
          fontColor={Colors.brandOne}
          fontSize="1.375rem"
          fontWeight="700"
        >
          {Text.seeYouSoon}
        </TextFont>
        <TextFont fontColor={Colors.mineShaft} fontSize="1rem" fontWeight="400">
          {Text.areYouSureYouWantToLogout}
        </TextFont>
        <ButtonsWrapper>
          <Button
            label={Text.cancel}
            onClick={setClose}
            bgColor={Colors.white}
            topBottomPadding="0.875rem"
            fontColor={Colors.black}
            fontSize={"1rem"}
            fontWeight="400"
            outlineColor={Colors.black}
          />
          <Button
            label={Text.yesLogout}
            onClick={onLogout}
            bgColor={Colors.red}
            topBottomPadding="0.875rem"
            fontSize="1rem"
            fontWeight="400"
          />
        </ButtonsWrapper>
      </LogoutContainer>
    </Modal>
  );
};

export default LogoutModal;

const LogoutContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 0.5rem;
  padding: 2.5rem 2rem;
  @media only screen and (max-width: 500px) {
    > img {
      width: 40%;
    }
  }
`;
const ButtonsWrapper = styled.div`
  display: flex;
  gap: 1rem;
  padding-top: 2rem;
  width: 21.875rem;
  @media only screen and (max-width: 500px) {
    flex-direction: column-reverse;
    width: 17.4375rem;
  }
`;
